import React, { useState } from "react";

interface ModalInputCapitalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: (value: number) => void;
}

const ModalInputCapital: React.FC<ModalInputCapitalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [inputValue, setInputValue] = useState<string>("");

  const handleConfirm = () => {
    const numeric = Number(inputValue.replace(/[^0-9]/g, ""));
    if (!Number.isNaN(numeric) && onConfirm) {
      onConfirm(numeric);
    }
  };

  return (
    <div
      className={`model-group ${isOpen ? "active" : ""}`}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        display: isOpen ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        className="model-item"
        style={{
          position: "relative",
          width: 598,
          height: 362,
          maxWidth: "95vw",
          maxHeight: "95vh",
          padding: "32px 40px",
          margin: "0 auto",
          color: "#ffffff",
          fontFamily: "Prompt, sans-serif",
          backgroundImage: 'url("/assets/bg-frame.png")',
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 18,
            background: "transparent",
            border: "none",
            color: "#ffffff",
            fontSize: 24,
            cursor: "pointer",
          }}
        >
          ×
        </button>

        <h1
          style={{
            fontSize: 35,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 1,
            textAlign: "center",
            marginBottom: 24,
          }}
        >
          Vui lòng nhập số vốn
        </h1>

        <div style={{ width: "100%", maxWidth: 420 }}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Nhập số tiền..."
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: 6,
              border: "1px solid rgba(0, 255, 157, 0.5)",
              backgroundColor: "rgba(0, 0, 0, 0.45)",
              color: "#ffffff",
              fontSize: 16,
              outline: "none",
              boxSizing: "border-box",
              marginBottom: 24,
            }}
          />

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="button"
              onClick={handleConfirm}
              style={{
                minWidth: 140,
                padding: "10px 24px",
                fontSize: 16,
                fontWeight: 600,
                color: "#003322",
                background:
                  "linear-gradient(180deg, #ffffff 0%, #9dffe0 50%, #3bff8c 100%)",
                borderRadius: 999,
                border: "none",
                cursor: "pointer",
                boxShadow: "0 0 18px rgba(0, 255, 157, 0.75)",
              }}
            >
              Đồng ý
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInputCapital;

